<div class="flex flex-col gap-4 p-2" [class]="direction" [ngClass]="{ 'w-[30.25rem]': !isMobile }">
  <!--
    a11y: explicit close (X) button added at the top of the rating popup.
    The audit requires every popup to:
      1) expose a close button at its top, and
      2) move initial focus to it on open.
    We mark it with [focusInitial]=true so CDK FocusTrap.focusInitialElement
    targets the inner native <button>. It comes FIRST in DOM order so Tab
    flows close -> heading -> stars -> send -> bottom close.
  -->
  <div class="flex justify-end">
    <mot-button matType="icon" icon="close"
      [ariaLabel]="closeText"
      [focusInitial]="true"
      (onClick)="closeCard(!!submittedRating ? data.rating : null)" />
  </div>

  <div class="flex flex-col gap2">
    <!--
      a11y: popup heading is h2, not h1. The page already has its primary <h1>
      (the site logo wrapper in nav-bar), so nested dialogs must continue the
      heading outline at level 2 to avoid breaking the document hierarchy.
    -->
    <h2 id="line-rating-popup-heading" class="text-center"> {{this.data.entityType === 0 ? howToRateStationText : howToRateLineText}}</h2>
    <app-star-rating
      [rating]="selectedRating"
      ariaLabelledBy="line-rating-popup-heading"
      (onRatingChanged)="selectedRating = $event"
      />
    </div>

    <!--
      a11y: live region for the post-submit status. The visible state button
      changes from "Send" to a disabled "Rating sent successfully" button — a
      change that screen readers don't pick up by themselves. role="status"
      (implicit aria-live="polite", aria-atomic="true") makes the SR speak the
      new message once the rating request resolves. Kept permanently in the DOM
      so AT registers the live region BEFORE its text changes.
    -->
    <p role="status" aria-live="polite" aria-atomic="true" class="sr-only">
      {{ statusAnnouncement }}
    </p>

    <div class="flex justify-center gap-2" [ngClass]="{ 'flex-col': !!isMobile }">
      @if (!submittedRating) {
        <mot-button buttonClass="not-disabled:!bg-primary w-full !text-white !py-6 !rounded-lg !align-middle" [text]="sendText"
          [disabled]="!selectedRating" (onClick)="handleSubmitRating()" />
        } @else {
          @if (!errorSubmitting) {
            <mot-button buttonClass="!bg-secGreen w-full !py-6 !px-8 !rounded-lg !align-middle"
              [text]="ratingSentSuccessfullyText" [disabled]="true" />
          }
          @if (!!errorSubmitting) {
            <mot-button buttonClass="!bg-red-300 w-full !py-6 !px-8 !rounded-lg !align-middle"
              [text]="ratingErrorText" [disabled]="true" />
          }
        }

        <!--
          a11y: wrapper picked up via @ViewChild so we can programmatically
          move focus here after submission (the previously-focused "Send"
          button has just been removed from the DOM).
        -->
        <span #closeBtnWrapper class="contents">
          <mot-button buttonClass="!bg-transparent w-full !py-6 !rounded-lg !align-middle" [text]="closeText"
            (onClick)="closeCard(!!submittedRating ? data.rating : null)" />
        </span>
        </div>
      </div>



